import React from 'react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import CustomButton from './CustomButton';
import { ButtonProps } from '@chakra-ui/react';
import { FaSave } from 'react-icons/fa';

type Props = {
  isLoading?: boolean,
  isSubmitting?: boolean,
} & ButtonProps;

const CustomSaveBtn: React.FC<Props> = ({
  isLoading,
  isSubmitting,
  ...rest
}) => {
  return (
    <CC.Skeleton isLoaded={!(!!isLoading)}>
      <CustomButton {...rest} isLoading={isSubmitting} type={'submit'}>
        <FaSave style={{ marginRight: '10px' }} /> Enregistrer
      </CustomButton>
    </CC.Skeleton>
  );
};

export default CustomSaveBtn;
